(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
      , 'pikaday'
      , 'ngSanitize'
      , '720kb.tooltips'
    );

  angular.module('MktzapApp.Controllers').controller('HistoryController', history);

  history.$inject = ['$scope', 'FoundationApi', '$http', 'ngTableParams', '$sce', 'NotificationService', '$filter', 'StatusService', 'SectorService', 'OperatorService', 'HistoryService', 'UserService', '$rootScope', 'ConversationService', '$stateParams', 'ChannelManager', 'UtilsService','$location'];

  function history ($scope, FoundationApi, $http, ngTableParams, $sce, NotificationService, $filter, StatusService, SectorService, OperatorService, HistoryService, UserService, $rootScope, ConversationService, $stateParams, ChannelManager, UtilsService, $location) {
    var vm = this

    vm.filteredUsers = []
    vm.pdf = {};
    vm.channelManager = ChannelManager;
    vm.phoneMask = '(99) 9?9999-9999';

    var now = moment().format('X');

    ConversationService
    .getMetadataDefinition()
    .$promise
    .then(function (data) {
      vm.metadata_definition = data;
    })
    .catch(function (error) {
      NotificationService.errorHandler(error, $scope.labels.errorLoadFiel);
    });

    function formatTime (seconds) {
      if (seconds == 0) { return ''; }
      var minutes = parseInt(seconds / 60) % 60;
      var hours = parseInt(seconds / 3600);
      var days = parseInt(seconds / (3600 * 24));

      if (days > 0) {
        return days + 'd';
      }
      if (hours > 0) {
        return hours + 'h';
      }
      if (minutes > 0) {
        return minutes + 'm';
      }

      return seconds + 's';
    }

    vm.getTme = function (history) {
      return formatTime(Math.round(history.waiting_time_medium));
    }

    function validateHistoryMenuPermission (){
      if ($rootScope.company_metadata.allow && $rootScope.company_metadata['history_menu'] && $rootScope.company_metadata['history_menu'].branch == true && $rootScope.user_data.role != $rootScope.profiles.ROLE_ADMIN)  {
        if (
          ($rootScope.company_metadata['history_menu'].user_operator && $rootScope.profiles.ROLE_OPERATOR == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_manager && $rootScope.profiles.ROLE_MANAGER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_promoter && $rootScope.profiles.ROLE_PROMOTER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_administrator && $rootScope.profiles.ROLE_MESSAGES_PORTAL_MANAGER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_supervisor && $rootScope.profiles.ROLE_MESSAGES_PORTAL_SUPERVISOR == $rootScope.user_data.role)
        ) {
            return true;
          }
          $location.path("");
      }
      return true ;
    }
    validateHistoryMenuPermission()

    vm.getTo = function (history) {
      if (!history.first_start_chat_at) return formatTime(0);
      if (!history.closed_at) return '-';
      var closed_at = moment(history.closed_at + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').format('X');
      var to_seconds = closed_at - history.first_start_chat_at;
      if (to_seconds < 0) {
        to_seconds = 0;
      }
      return formatTime(to_seconds);
    	}

    	vm.dateSelected = function (type, date) {
    		if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
    		}
    		if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
    		}
    	};

    	vm.filters = {
    		fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      status_id: '',
      number: '',
      cpf: '',
      contract: '',
      sector_id: '',
      closed_by_user: '',
      channelable_type: '',
      email: '',
      document_history: ''
    	};

    	if ($stateParams.filters) {
      vm.filters.fromDate = moment($stateParams.filters.fromDate, 'DD/MM/YYYY').format('DD/MM/YYYY');
      vm.filters.toDate = moment($stateParams.filters.toDate, 'DD/MM/YYYY').format('DD/MM/YYYY');
      vm.filters.only_open = true;
    }

    vm.channelable_types = ChannelManager.getHistoryChannelTypes();

    	StatusService
    	.statuses_with_trashed()
      .$promise
      .then(function (data) {
        vm.statuses_with_trashed = data;
      }).catch(function (data) {
        NotificationService.errorHandler(data, $scope.labels.errorLoadStatus);
      });

    SectorService.sectors_with_trashed()
      .$promise
      .then(function (data) {
        vm.sectors_with_trashed = data;
      })
      .catch(function (data) {
        NotificationService.errorHandler(data, $scope.labels.errorLoadDepart);
      });

    UserService
      .getUsersByRoles([0, 1, 1000])
      .$promise
      .then(function (data) {
        vm.filteredUsers = data
      })
      .catch(function () {
        NotificationService.errorHandler('', $rootScope.labels.requestError)
      })

    vm.getType = getType;
    vm.showHistory = showHistory;
    vm.restoreHistory = restoreHistory;
    vm.getClass = getClass;
    vm.filterMessage = filterMessage;
    vm.download = download;
    vm.search = search;
    vm.downloadComplete = downloadComplete;
    vm.attachments = attachments;
    vm.getCompanyLocalization = getCompanyLocalization;
    vm.downloadCompleteHistory = downloadCompleteHistory;
    vm.changeDdi = changeDdi

    getCountries()

    function getType (history) {
      return ChannelManager.getType(history);
    }

    function filterMessage (message) {
      const imageDefault = "'" + window.location.origin + baseUrl + '/assets/images/placeholder.jpg' + "'"

      if (!message) {
        return;
      }
      var matches = message.match(/\[image channel="(.+)" file="(.+)"\]/);
      if (matches) {
        var channel = matches[1];
        var file = matches[2];
        message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + baseUrl + '/channel_media/' + channel + '/' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.viewImage(this.src)"/>';
        message = $sce.trustAsHtml(message);
        return message;
      }
      var matches = message.match(/\[attachment config_id="(.+)" file="(.+)" name="(.+)"\]/);
      if (matches) {
        var id = matches[1];
        var file = matches[2];
        var name = matches[3];
        if (name.match(/^http/) != null) {
                	var swap = file;
                	file = name;
                	name = swap;
        }
        message = '<a href="' + file + '" target="_blank" >Anexo: ' + name + '</a>';
        message = $sce.trustAsHtml(message);
        return message;
      }
      var matches = message.match(/\[attachment config_id="(.+)" name="(.+)" file="(.+)"\]/);
      if (matches) {
        var id = matches[1];
        var name = matches[2];
        var file = matches[3];
        if (name.match(/^http/) != null) {
                	var swap = file;
                	file = name;
                	name = swap;
        }
        message = '<a href="' + file + '" target="_blank" >Anexo: ' + name + '</a>';
        message = $sce.trustAsHtml(message);
        return message;
      }
      var matches = message.match(/\[image provider="(.+)" key="(.+)" file="(.+)"(?: name="(.+)")?\]/);
      if (matches) {
        var provider = matches[1];
        var key = matches[2];
        var file = matches[3];
        if (provider == 's3') {
          message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.viewImage(this.src)"/>';
          message = $sce.trustAsHtml(message);
          return message;
        }
      }
      var matches = message.match(/\[media type="(.+)" provider="(.+)" key="(.+)" file="(.+?)"(?: name="(.+)")?\]/);
      if (matches) {
        var type = matches[1];
        var provider = matches[2];
        var key = matches[3];
        var file = matches[4];
        filename = matches.length === 6 ? matches[5] : '';
        if (provider == 's3') {
          if (type == 'image') {
            message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.viewImage(this.src)"/>';
          } else if (type == 'video') {
            message = '<br><video controls="" src="' + file + '"></video>';
          } else if (type == 'audio') {
            			message = '<br><audio controls="" src="' + file + '"></audio>';
          			} else if (type == 'document') {
            			message = '<br><a href="' + file + '" target="_blank" >"' + $scope.labels.seeFile + ' ' + filename + '".</a>';
          			}
          message = $sce.trustAsHtml(message);
          return message;
        }
      }
      return message;
    }
	    function showHistory (id, reload) {
	    	var params = { id: id }
	    	if (!reload) {
        vm.showAllContactMessages = false;
        FoundationApi.publish('dlgChatModal', 'open');
      }
      if (vm.showAllContactMessages) params.allMessages = true;
	    	vm.is_loading = true;
    		HistoryService
	        	.find(params)
	        	.$promise
	        	.then(function (data) {
        			vm.messages = data.messages;
          vm.selected_history = data.history;
          vm.selected_history_data = vm.channelManager.getHistoryContactData(data.history);
	    			vm.is_loading = false;
        }).catch(function (data) {
          NotificationService.errorHandler(data, $scope.labels.errorListHist);
        });
	    }

	    function restoreHistory (history) {
	    	HistoryService
	        	.restoreContact({
	        		id: history.id
	        	}, {})
	        	.$promise
	        	.then(function (data) {
          if (data.success) {
            history.status = null;
        			    history.closed_at = null;
        			    NotificationService.successHandler(data, data.message, 6000);
          } else if (data.type == 'warning') {
            NotificationService.warningHandler(data, data.message, 6000);
          } else {
            NotificationService.errorHandler(data, $scope.labels.errorResAtt);
          }
        }).catch(function (reponse) {
          if (reponse.data.alert) {
        			    NotificationService.warningHandler(reponse, reponse.data.message, 6000);
	        		} else {
            NotificationService.errorHandler(reponse, $scope.labels.errorResAtt);
	        		}
        });
	    }

       	function download (history) {
      $http.get(apiUrl + '/history/download/' + history.id)
        .then(function ({ data, status, headers }) {
          var filename = headers('Mktzap-Filename') || 'conversation_detail' + '.csv';

          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' });
          angular.element(document.body).append(anchor);

          var blob = new Blob([data], { type: 'text/csv' });
          var csvUrl = URL.createObjectURL(blob);

          anchor.attr({
            href: csvUrl,
            target: '_self',
            download: filename
          })[0].click();

          anchor.remove();
          URL.revokeObjectURL(csvUrl);
        }, function ({ data }) {
          errorHandler(null, $scope.labels.errorLoadHist)
        })
	    }

    function getClass (message) {
      var messageClass = 'right';

      if (message.sent_by_operator == '0') {
        messageClass = 'left';
      }
      return messageClass;
    }

    function search (is_report) {
      vm.historyTable = new ngTableParams({
		        page: 1, // show first page
		        count: 50, // count per page
		        is_report: is_report
		    }, {
		    	counts: [25, 50, 100],
		        getData: function ($defer, params) {
		        	var obj = params.url();
	                var keys = Object.keys(vm.filters);
	                for (var i = 0; i < keys.length; i++) {
	                    var filterValue = vm.filters[keys[i]];
	                    if (filterValue != null && filterValue !== '') {
	                        obj['filter[' + keys[i] + ']'] = filterValue;
	                    }
	                }
	   				if (is_report) {
            vm.downloadComplete(obj);
            vm.data_total = 0;
            vm.data_result = 'download';
	   				} else {
			        	HistoryService
			        	.paged(obj)
			        	.$promise
			        	.then(function (data) {
		        			params.total(data.total);
                $defer.resolve(data.result);
                vm.data_total = data.total;
                vm.data_result = data.result.length;
              }).catch(function (data) {
                NotificationService.errorHandler(data, $scope.labels.errorLoadHist);
              });
	   				}
		        }
      });
    }

    function downloadComplete (obj) {
        	vm.loading = true;
	        $http.get(apiUrl + '/history', { params: obj })
			  .then(function ({ data, status, headers }) {
			  		if (data.success !== null && data.success === false) {
            NotificationService.errorHandler(data, data.error.time);
            vm.loading = false;
          } else {
            var filename = headers('Mktzap-Filename') || $scope.labels.reportName;
            var anchor = angular.element('<a/>');

            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([data], { type: 'text/csv' });
            var csvUrl = URL.createObjectURL(blob);

            // IE 10 / 11
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
              return;
            }

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();
            anchor.remove();
            URL.revokeObjectURL(csvUrl);
            vm.loading = false;
          }
		        }, function ({ data }) {
		        	NotificationService.errorHandler(data, $scope.labels.errorGenReport);
		            vm.loading = false;
		        })
    }

    vm.filterMessageMediaToPrint = function (message) {
      var matches = message.match(/\[media type="(.+)" provider="(.+)" key="(.+)" file="(.+?)"(?: name="(.+)")?\]/);
      if (matches) {
        var type = matches[1];
        var provider = matches[2];
        var key = matches[3];
        var file = matches[4];
        if (provider == 's3') {
          if (type == 'image') {
            message = '<br><img style="max-width: 50%;" src="' + file + '"/>';
          } else if (type == 'video') {
            message = '<br><a target="_blank" href="' + file + '">' + $scope.labels.seeVideo + '</a>';
          } else if (type == 'audio') {
            message = '<br><a target="_blank" href="' + file + '">' + $scope.labels.listenAudio + '</a>';
          } else if (type == 'document') {
            message = '';
          }
          return message;
        }
      }
      return null;
    }

    function attachments (history) {
		  vm.is_loading = true;
      HistoryService
        .attachment({ id: history.id })
        .$promise
        .then(function (data) {
          if (data.success) {
			  		openModalAttachments(history, data)
			  } else {
            NotificationService.warningHandler(data, $scope.labels.errorNoAttachments);
          }
        }).catch(function (data) {
          vm.is_loading = false;
          NotificationService.errorHandler(data, $scope.labels.errorLoadAttachments);
        });
    }

    vm.generateSignedCCB = function (history, proposal, proposalNumber) {
      NotificationService.warningHandler(null, $scope.labels.requestHasProcessed);

      if (multipleClients) {
        var multipleClientsFlow = vm.digitalSignatureAttachments.commandProcessor;
      }

      HistoryService
        .generateSignedCCB({
          history: history,
          proposal: proposal,
          proposalNumber: proposalNumber,
          multipleClients: multipleClients,
          multipleClientsFlow: multipleClientsFlow,
          indexProposal: indexProposal
        })
        .$promise
        .then(function (data) {
          if (data.success) {
            vm.validProposal = false;
            attachments(history)
          } else {
            NotificationService.errorHandler(data, $scope.labels.ccbNotFound);
          }
        }).catch(function (data) {
			  vm.is_loading = false;
			  NotificationService.errorHandler(data, $scope.labels.ccbNotFound);
        });
    }

    function openModalAttachments (history, data) {
      if (data.commandProcessorType == 'multipleClients') {
        FoundationApi.publish('modalMultipleClientsFormalization', 'open');
      } else {
        FoundationApi.publish('modalDigitalSignature', 'open');
      }
      vm.digitalSignatureAttachments = data;
      vm.selected_history = history;
      vm.is_loading = false;
    }

    vm.downloadSignedCCB = function (history, signedCcbs, proposal) {
      if (typeof (signedCcbs) === 'object') {
        angular.forEach(signedCcbs, function (url, key) {
          validateUrl(url, proposal)
            .then(function () {
              if (vm.validProposal == proposal) {
                attachments(history)
              } else {
                vm.downloadByUrl(url);
              }
            });
        });
      } else {
        NotificationService.errorHandler(null, $scope.labels.errorOperation);
      }
    }

    vm.enablePDFButton = function () {
      return ($rootScope.company_metadata.hasOwnProperty('allow') && $rootScope.company_metadata.allow['history_pdf_button']);
    }

    vm.exportHtml2Pdf = function (contact_id, history_id) {
      angular.element('.messagesContent').css({ display: 'block' })
      angular.element('.messagesContent').css({ display: 'inline' })

      vm.sending = true
      $http({
        url: baseUrl + '/html-to-pdf',
        method: 'POST',
        data: { historyId: history_id },
        responseType: 'arraybuffer'
      })
        .then(function (data) {
          if (data.success === false) {
            NotificationService.errorHandler(data, 'Erro ao gerar relatório.');
            return;
          }

          if (data) {
            filename = contact_id + '.pdf'
            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([data.data], { type: 'application/pdf;charset=utf-8' });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove(); // Clean it up afterwards
            URL.revokeObjectURL(csvUrl); // Clean memory blob
            vm.sending = false;
          } else {
                	vm.sending = false;
            NotificationService.errorHandler(null, 'Sem dados neste período.');
          }
        }, function (data) {
            	vm.sending = false;
          NotificationService.errorHandler(data, 'Erro ao gerar relatório.');
        })
    }

    function downloadCompleteHistory (obj) {
      vm.loading = true;
	        $http.get(apiUrl + '/history/export', { params: obj })
			  	.then(function ({ data, status, headers }) {
          if (data.error_message) {
            if (data.error_message == 'timeouterror') {
              vm.timeouterror = true;
              FoundationApi.publish('sendBackground', 'open');
            } else {
              NotificationService.errorHandler(data, data.error_message);
            }
          } else {
            if (data['alert']) {
              NotificationService[data['alert'] + 'Handler'](data);
              if (data['alert'] == 'success') {
                vm.sentToBackground = true;
              } else {
                FoundationApi.publish('sendBackground', 'close');
              }
            } else {
              var filename = headers('Mktzap-Filename') || 'mktzap_relatorio_historico.csv';
              var anchor = angular.element('<a/>');

              anchor.css({ display: 'none' }); // Make sure it's not visible
              angular.element(document.body).append(anchor); // Attach to document

              var blob = new Blob([data], { type: 'text/csv' });
              var csvUrl = URL.createObjectURL(blob);

              // IE 10 / 11
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
                return;
              }

              anchor.attr({
                href: csvUrl,
                target: '_self',
                download: filename
              })[0].click();
              anchor.remove();
              URL.revokeObjectURL(csvUrl);
              vm.data_result = 'download';
            }
            vm.timeouterror = false;
          }
		            vm.loading = false;
		        }, function ({ data }) {
          NotificationService.errorHandler(data, 'Não foi possível gerar o relatório de histórico!');
          vm.loading = false;
        })
    }

    vm.downloadByUrl = function (url) {
      var anchor = angular.element('<a/>');
      anchor.css({ display: 'none' });
      angular.element(document.body).append(anchor);
      anchor.attr({
        href: url,
        target: '_blank',
        download: 'Baixar CBB'
      })[0].click();
      anchor.remove();
    }

    function validateUrl (url, proposal) {
      return new Promise(function (resolve, reject) {
        const http = new XMLHttpRequest();
        http.open('GET', url);
        http.send();
        http.onreadystatechange = function () {
          if (http.status === 403) {
            vm.validProposal = proposal;
            resolve('success');
          } else {
            vm.validProposal = false;
            resolve('false');
          }
        }
      });
    }

    function getCountries ()
    {
      HistoryService
        .getCountries()
        .$promise
        .then(function (data) {
          if (data) {
            vm.countries = data.countries;
            getCompanyLocalization();
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.errorLoadingTemplates);
        });
    }

    function getCompanyLocalization ()
    {
      HistoryService
        .getCompanyLocalization()
        .$promise
        .then(function (data) {
          if (data.value) {
            data = JSON.parse(data.value);
            vm.filters.ddi = parseInt(data.country);

            vm.countries.forEach(function(country) {
              if (data.country == country.id) {
                vm.filters.ddi = parseInt(country.ddi);
              }
            });
          } else {
            vm.filters.ddi = 55;
          }
          changeDdi(vm.filters.ddi);
        }).catch(function (data) {
          vm.filters.ddi = 55;
          changeDdi(vm.filters.ddi);
        });
    }

    function changeDdi(ddi)
    {
      vm.countries.forEach(function(country, index){
        if (ddi == country.ddi) {
          vm.phoneMask = country.mask ? country.mask : '';
        }
      });
    }

    vm.hasAllowPhoneMask = function (input) {
      return UtilsService.hasAllowPhoneMask(input);
    };


    vm.clearFilters = function () {
      vm.metadata_definition.forEach(metaData =>{
        vm.filters.key[metaData.key] = '';
      });
      vm.filters.fromDate = moment().startOf('month').format('DD/MM/YYYY');
      vm.filters.toDate = moment().endOf('month').format('DD/MM/YYYY');
      vm.filters.name = '';
      vm.filters.ddi = '';
      vm.filters.number = '';
      vm.filters.email = '';
      vm.filters.protocol = '';
      vm.filters.sector_id = '';
      vm.filters.channelable_type = '';
      vm.filters.status_id = '';
      vm.filters.closed_by_user = '';
      vm.filters.only_open = '';
    }
  }
})();
